import { createSelector } from '@reduxjs/toolkit';
import { AssigneesResI } from '../models/Assignees';

export const assigneesStoreStateSelector = (state) => state.assignees;
export const assigneesDataSelector = createSelector(
  assigneesStoreStateSelector,
  (storeState): AssigneesResI => storeState.assignees || [],
);

export const loadingAssigneesSelector = createSelector(
  assigneesStoreStateSelector,
  (storeState): boolean => storeState.isLoading,
);

export const loadDataErrorAssigneesSelector = createSelector(
  assigneesStoreStateSelector,
  (storeState): boolean => storeState.error,
);

export const dropdownAssigneesSelector = createSelector(
  assigneesDataSelector,
  (assignees) =>
    assignees.map((assignee) => ({
      value: assignee.id,
      label: assignee.name || assignee.address,
      hoverText: assignee.address,
      imageUrl: assignee.imageUrl,
    })),
);
